export default {
  delivery_tracking: "Delivery Tracking",
  order: "Order",
  live_tracking: "Live Tracking",

  driver: "Driver",
  vehicle: "Vehicle",
  eta: "ETA",
  status: "Status",
  arriving_in: "Arriving In",
  distance: "Distance",
  destination: "Destination",

  open_navigation: "Open Full Navigation",
  last_updated: "Last updated",

  arriving: "Arriving",
  mins: "mins",

  delivery_completed_success: "Delivery Completed Successfully",

  status_assigned: "Driver Assigned",
  status_on_way: "On the Way",
  status_delivered: "Delivered"
};